export default __webpack_public_path__ + "static/media/play-button-white-circle-solid.02c18061.svg";